var map = {
	"./logo-1.svg": 1200,
	"./logo-2.svg": 1201,
	"./logo-3.svg": 1202,
	"./logo-4.svg": 1203,
	"./logo-5.svg": 1204,
	"./logo-6.svg": 1205,
	"./logo-7.svg": 1206,
	"./logo-8.svg": 1207
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1199;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-img/svg-img ^\.\/logo\-.*\.svg$
// module id = 1199
// module chunks = 173